import { Vertical, VerticalConfig, VerticalConfigs } from 'utils/vertical';
import { LinksConfig } from 'types/navigation';
import { ARTISTS_SMARTLING_LOCALES, CONSUMER_SMARTLING_LOCALES } from 'utils/i18n/localeConfig';
import { s4aLaunchedBool } from 'utils/remote-config/properties';

export const artistsLinksConfig: LinksConfig = [
  { label: 'Get started', href: 'https://artists.spotify.com/get-started' },
  { label: 'Features', href: 'https://artists.spotify.com/features' },
  {
    label: 'Resources',
    menuKey: 'resources',
    links: [
      { label: 'Videos', href: 'https://artists.spotify.com/videos' },
      { label: 'News', href: 'https://artists.spotify.com/blog' },
      { label: 'Events', href: 'https://artists.spotify.com/events' },
      {
        label: 'In Focus',
        href: 'https://artists.spotify.com/infocus?utm_campaign=top-nav&utm_medium=owned-product&utm_source=s4a',
      },
      {
        label: 'Fan Study',
        href: 'https://artists.spotify.com/fanstudy?utm_campaign=top-nav&utm_medium=owned-product&utm_source=s4a',
      },
      {
        label: 'Made to Be Found',
        href: 'https://artists.spotify.com/found?utm_campaign=top-nav&utm_medium=owned-product&utm_source=s4a',
      },
      {
        label: 'Loud & Clear',
        href: 'https://artists.spotify.com/loudandclear?utm_campaign=top-nav&utm_medium=owned-product&utm_source=s4a',
      },
      {
        label: 'Noteable',
        href: 'https://artists.spotify.com/noteable?utm_campaign=top-nav&utm_medium=owned-product&utm_source=s4a',
      },
    ],
  },
  { label: 'Help', href: 'https://artists-support.spotify.com' },
];

// These configs might be available in frontend, so don't add anything sensitive like secrets etc
const verticalConfigs: VerticalConfigs = {
  [Vertical.ARTISTS]: {
    verticalName: Vertical.ARTISTS,
    pathParam: 'artists',
    cms: {
      dataset: process.env.VERTICAL_ARTIST_DATASET ?? 'artists_production',
      projectId: 'tsbk0zvv',
      apiVersion: '2021-10-21',
    },
    features: {
      communityLink: null,
      showHeaderGradient: false,
      configureNavigation: {
        colorSet: 'encore-inverted-dark-set',
        linksConfig: artistsLinksConfig,
      },
      configurePillowTalk: {
        lineOfBusiness: 'S4A',
      },
    },
    locales: ARTISTS_SMARTLING_LOCALES,
    theme: 'encore-creator-light-theme',
    rolloutProperty: s4aLaunchedBool,
  },
  [Vertical.CONSUMER]: {
    verticalName: Vertical.CONSUMER,
    pathParam: '',
    cms: {
      dataset: process.env.VERTICAL_CONSUMER_DATASET ?? 'production',
      projectId: 'tsbk0zvv',
      apiVersion: '2021-10-21',
    },
    features: {
      communityLink: 'https://community.spotify.com/t5/Spotify-Answers/tkb-p/Spotify-Answers',
      showHeaderGradient: true,
      configureNavigation: null,
      configurePillowTalk: null,
    },
    locales: CONSUMER_SMARTLING_LOCALES,
    theme: 'encore-dark-theme',
    rolloutProperty: null,
  },
} as const;

export const getVerticalConfigs = (): VerticalConfigs => verticalConfigs;

export const getVerticalConfig = (vertical: Vertical): VerticalConfig => {
  return verticalConfigs[vertical];
};
